var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60,32c0-2.211-1.789-4-4-4H44V4c0-2.211-1.789-4-4-4H24c-2.211,0-4,1.789-4,4v12H8c-2.211,0-4,1.789-4,4 v44h56V32z M20,56h-8V24h8V56z M36,32v24h-8V20V8h8V32z M52,56h-8V36h8V56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    fill: "#B4CCB9",
    width: 8,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    fill: "#45AAB8",
    width: 8,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    fill: "#F76D57",
    width: 8,
    height: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.53e3ca2351d995b375a969e68f71eef3.svg";
export { ForwardRef as ReactComponent };